import api from './api'

export const report = {

  carPresentList: (params) => {
    return api.post(`/CloudParkAPI/Report/CarPresentList`, params)
  },
  greenCarPresentList: (params) => {
    return api.post(`/CloudParkAPI/Report/GreenCarPresentList`, params)
  },
  carBusInfo: (params) => {
    return api.post(`/CloudParkAPI/Report/CarBusInfo`, params)
  },
  carBusPayInfo: (params) => {
    return api.post(`/CloudParkAPI/Report/carBusPayInfo`, params)
  },
  carDepartureList: (params) => {
    return api.post(`/CloudParkAPI/Report/carDepartureList`, params)
  },
  greenCarDepartureList: (params) => {
    return api.post(`/CloudParkAPI/Report/GreenCarDepartureList`, params)
  },
  carTurnoverList: (params) => {
    return api.post(`/CloudParkAPI/Report/carTurnoverList`, params)
  },
  carDevInfo: (params) => {
    return api.post(`/CloudParkAPI/Report/carDevInfo`, params)
  },
  deleteCarPresent: (params) => {
    return api.post(`/CloudParkAPI/Report/deleteCarPresent`, params)
  },
  syncCarPresent: (params) => {
    return api.post(`/CloudParkAPI/Report/SyncCarPresent`, params)
  },
  syncCarDeparture: (params) => {
    return api.post(`/CloudParkAPI/Report/SyncCarDeparture`, params)
  },
  carChargeDetailList: (params) => {
    return api.post(`/CloudParkAPI/Report/CarChargeDetailList`, params)
  },
  chargeDetailExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/ChargeDetailExport`, params)
  },
  carPresentExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/CarPresentExport`, params)
  },
  greenCarPresentExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/GreenCarPresentExport`, params)
  },
  dailyChargeList: (params) => {
    return api.post(`/CloudParkAPI/Report/DailyChargeList`, params)
  },
  dailyChargeExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/DailyChargeExport`, params)
  },
  custChargeList: (params) => {
    return api.post(`/CloudParkAPI/Report/CustChargeList`, params)
  },
  custChargeExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/CustChargeExport`, params)
  },
  payDataList: (params) => {
    return api.post(`/CloudParkAPI/Report/PayDataList`, params)
  },
  etcPayDataList: (params) => {
    return api.post(`/CloudParkAPI/Report/EtcPayDataList`, params)
  },
  etcPayErrorDataList: (params) => {
    return api.post(`/CloudParkAPI/Report/EtcPayErrorDataList`, params)
  },
  deleteEtcPayDataList: (params) => {
    return api.post(`/CloudParkAPI/Report/DeleteEtcPayDataList`, params)
  },
  deleteEtcPayErrorData: (params) => {
    return api.post(`/CloudParkAPI/Report/DeleteEtcPayErrorData`, params)
  },
  couponDataList: (params) => {
    return api.post(`/CloudParkAPI/Report/couponDataList`, params)
  },
  eCashPayList: (params) => {
    return api.post(`/CloudParkAPI/Report/eCashPayList`, params)
  },
  carDepartureExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/CarDepartureExport`, params)
  },
  greenCarDepartureExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/GreenCarDepartureExport`, params)
  },
  carTurnoverExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/CarTurnoverExport`, params)
  },
  handoverList: (params) => {
    return api.post(`/CloudParkAPI/Report/HandoverList`, params)
  },
  handoverInfo: (params) => {
    return api.post(`/CloudParkAPI/Report/HandoverInfo`, params)
  },
  handoverPayInfo: (params) => {
    return api.post(`/CloudParkAPI/Report/HandoverPayInfo`, params)
  },
  handoverExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/HandoverExport`, params)
  },
  handoverDetailExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/HandoverDetailExport`, params)
  },
  handoverBusHisList: (params) => {
    return api.post(`/CloudParkAPI/Report/HandoverBusHisList`, params)
  },
  paymentExceptionList: (params) => {
    return api.post(`/CloudParkAPI/Report/PaymentExceptionList`, params)
  },
  paymentExceptionListExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/PaymentExceptionListExport`, params)
  },
  redPacketList: (params) => {
    return api.post(`/CloudParkAPI/Report/RedPacketList`, params)
  },
  couponUsageList: (params) => {
    return api.post(`/CloudParkAPI/Report/CouponUsageList`, params)
  },
  wYYMCouponUsageList: (params) => {
    return api.post(`/CloudParkAPI/Report/WYYMCouponUsageList`, params)
  },
  hSCouponUsageList: (params) => {
    return api.post(`/CloudParkAPI/Report/HSCouponUsageList`, params)
  },
  bJXCCouponUsageList: (params) => {
    return api.post(`/CloudParkAPI/Report/BJXCCouponUsageList`, params)
  },
  paymentDetailsReport: (params) => {
    return api.post(`/CloudParkAPI/Report/PaymentDetailsReport`, params)
  },
  payDayDataList: (params) => {
    return api.post(`/CloudParkAPI/Report/PayDayDataList`, params)
  },
  eInvoiceDataList: (params) => {
    return api.post(`/CloudParkAPI/Report/EInvoiceDataList`, params)
  },
  retransmitById: (params) => {
    return api.post(`/CloudParkAPI/Report/RetransmitById`, params)
  },
  invoiceHongChong: (params) => {
    return api.post(`/CloudParkAPI/Report/InvoiceHongChong`, params)
  },
  paymentSummaryList: (params) => {
    return api.post(`/CloudParkAPI/Report/PaymentSummaryList`, params)
  },
  paymentSummaryListNew: (params) => {
    return api.post(`/CloudParkAPI/Report/PaymentSummaryListNew`, params)
  },
  sj_carModel: () => {
    return api.get(`/CloudParkAPI/FuDan/SJ_CarModel`)
  },
  illegalCarHandle: (params) => {
    return api.post(`/CloudParkAPI/FuDanCloud/IllegalCarHandle`, params)
  },
  illegalCarList: (params) => {
    return api.post(`/CloudParkAPI/FuDanCloud/IllegalCarList`, params)
  },
  getParkChnlVehiclesList: (params) => {
    return api.post(`/CloudParkAPI/FuDanCloud/GetParkChnlVehiclesList`, params)
  },
  getParkPlacesList: (params) => {
    return api.post(`/CloudParkAPI/FuDanCloud/GetParkPlacesList`, params)
  },
  deviceList: (params) => {
    return api.post(`/CloudParkAPI/FuDanCloud/DeviceList`, params)
  },
  deleteDevice: (params) => {
    return api.post(`/CloudParkAPI/FuDanCloud/DeleteDevice`, params)
  },
  deviceDetailList: (params) => {
    return api.post(`/CloudParkAPI/FuDanCloud/DeviceDetailList`, params)
  },
  getParkPIDList: (params) => {
    return api.post(`/CloudParkAPI/Report/GetParkPIDList`, params)
  },
  payCardDataList: (params) => {
    return api.post(`/CloudParkAPI/Report/PayCardDataList`, params)
  },
  getParkPlaceChar: (params) => {
    return api.post(`/CloudParkAPI/FuDanCloud/GetParkPlaceChar`, params)
  },
  etcPayInfo: (params) => {
    return api.post(`/CloudParkAPI/Report/EtcPayInfo`, params)
  },
  getPlateCorrectList: (params) => {
    return api.post(`/CloudParkAPI/Report/GetPlateCorrectList`, params)
  },
  reportModifyPlateCode: (params) => {
    return api.post(`/CloudParkAPI/Report/ModifyPlateCode`, params)
  },
  autoModifyPlate: (params) => {
    return api.post(`/CloudParkAPI/Report/AutoModifyPlate`, params)
  },
  allAutoModifyPlate: (params) => {
    return api.post(`/CloudParkAPI/Report/AllAutoModifyPlate`, params)
  },
  getBusHisAppselList: (params) => {
    return api.post(`/CloudParkAPI/Report/GetBusHisAppselList`, params)
  },
  uniformedVehiclesList: (params) => {
    return api.post(`/CloudParkAPI/GungaAirportReport/UniformedVehiclesList`, params)
  },
  abnormalVehiclesList: (params) => {
    return api.post(`/CloudParkAPI/GungaAirportReport/AbnormalVehiclesList`, params)
  },
  abnormalVehiclesNewList: (params) => {
    return api.post(`/CloudParkAPI/GungaAirportReport/AbnormalVehiclesNewList`, params)
  },
  tempCarFreeDepartureList: (params) => {
    return api.post(`/CloudParkAPI/GungaAirportReport/TempCarFreeDepartureList`, params)
  },
  tempCarHandFreeDepartureList: (params) => {
    return api.post(`/CloudParkAPI/GungaAirportReport/TempCarHandFreeDepartureList`, params)
  },
  monthlyCarDepartureList: (params) => {
    return api.post(`/CloudParkAPI/GungaAirportReport/MonthlyCarDepartureList`, params)
  },
  reconciliationDetailList: (params) => {
    return api.post(`/CloudParkAPI/GungaAirportReport/ReconciliationDetailList`, params)
  },
  unionPaySensorlessDataList: (params) => {
    return api.post(`/CloudParkAPI/GungaAirportReport/UnionPaySensorlessDataList`, params)
  },
  unionPayNonSensitiveDataList: (params) => {
    return api.post(`/CloudParkAPI/GungaAirportReport/UnionPayNonSensitiveDataList`, params)
  },
  weChatAlipayDataList: (params) => {
    return api.post(`/CloudParkAPI/GungaAirportReport/WeChatAlipayDataList`, params)
  },
  cashPaymentDetailList: (params) => {
    return api.post(`/CloudParkAPI/GungaAirportReport/CashPaymentDetailList`, params)
  },
  paymentReconciliationList: (params) => {
    return api.post(`/CloudParkAPI/Report/PaymentReconciliationList`, params)
  },
  eCouponReportList: (params) => {
    return api.post(`/CloudParkAPI/Report/ECouponReportList`, params)
  },
  eCouponReportSelectList: (params) => {
    return api.post(`/CloudParkAPI/Report/GetECouponReportSelectList`, params)
  },
  sCouponReportList: (params) => {
    return api.post(`/CloudParkAPI/Report/SCouponReportList`, params)
  },
  sCouponReportSelectList: (params) => {
    return api.post(`/CloudParkAPI/Report/GetSCouponReportSelectList`, params)
  },
  freeTimePlatelList: (params) => {
    return api.post(`/CloudParkAPI/Report/GetFreeTimePlatelList`, params)
  },
  freeTimePlateSelectList: (params) => {
    return api.post(`/CloudParkAPI/Report/GetFreeTimePlateSelectList`, params)
  },
  rechargeCardDataList: (params) => {
    return api.post(`/CloudParkAPI/Report/RechargeCardDataList`, params)
  },
  couPurPayReportList: (params) => {
    return api.post(`/CloudParkAPI/Report/CouPurPayReportList`, params)
  },
  cloudSeatList: (params) => {
    return api.post(`/CloudParkAPI/Report/CloudSeatList`, params)
  },
  cloudSeatListExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/CloudSeatListExport`, params)
  },
  cloudSeatDetailList: (params) => {
    return api.post(`/CloudParkAPI/Report/CloudSeatDetailList`, params)
  },
  paymentChannelList: (params) => {
    return api.post(`/CloudParkAPI/Report/PaymentChannelList`, params)
  },
  couPurPayList: (params) => {
    return api.post(`/CloudParkAPI/Report/CouPurPayList`, params)
  },
  paymentChannelListExport: (params) => {
    return api.post(`/CloudParkAPI/ReportExport/PaymentChannelListExport`, params)
  },
  pasOrOutVehicleStatisticsList: (params) => {
    return api.post(`/CloudParkAPI/Report/PasOrOutVehicleStatisticsList`, params)
  },
  shAppUploadList: (params) => {
    return api.post(`/CloudParkAPI/Report/ShAppUploadList`, params)
  },
  shAppUploadCountList: (params) => {
    return api.post(`/CloudParkAPI/Report/ShAppUploadCountList`, params)
  },
  shAppCustFloorList: (params) => {
    return api.post(`/CloudParkAPI/Report/ShAppCustFloorList`, params)
  },
  shAppCustAreaList: (params) => {
    return api.post(`/CloudParkAPI/Report/ShAppCustAreaList`, params)
  },
  shAppUploadImg: (params) => {
    return api.post(`/CloudParkAPI/Report/ShAppUploadImg`, params)
  },
  carOffCarResPreList: (params) => {
    return api.post(`/CloudParkAPI/Report/CarOffCarResPreList`, params)
  },
  carOffEhallCardList: (params) => {
    return api.post(`/CloudParkAPI/Report/CarOffEhallCardList`, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/report.js